import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createOrder, redirect } from "../../redux/actions/orders";
import { useNavigate } from "react-router-dom";

export default function AddOrder() {
  const navigate = useNavigate();

  const initialData = {
    fives: 0,
    tens: 0,
    fifteens: 0,
    twenty_fives: 0,
    fifties: 0,
    hundreds: 0,
    orderNo: null,
    orderDate: null,
  };

  const [inputData, setInputData] = useState(initialData);

  const { fives, tens, fifteens, twenty_fives, fifties, hundreds } = inputData;
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleSum = () => {
    const sum =
      fives * 5 +
      tens * 10 +
      fifteens * 15 +
      twenty_fives * 25 +
      fifties * 50 +
      hundreds * 100;

    return sum;
  };

  const { isLoading } = useSelector((state) => state.orders);

  useEffect(() => {
    if (!isLoading) {
      navigate(`/manager/`);
      dispatch(redirect());
    }
  }, [dispatch, isLoading, navigate]);

  const handleAddOrderClick = (e) => {
    e.preventDefault();

    dispatch(createOrder({ inputData }));
  };

  return (
    <div className="bg-gray-50">
      <div className="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <h2 className="sr-only">Checkout</h2>

        <form className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
          <div>
            <div className="mt-3">
              <h2 className="text-lg font-medium text-gray-900">
                Order information
              </h2>

              <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                <div>
                  <label
                    htmlFor="orderNo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Order Number
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="orderNo"
                      id="orderNo"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="orderNo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Order Date
                  </label>
                  <div className="mt-1">
                    <input
                      type="date"
                      name="orderDate"
                      className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-160 md:w-160 lg:w-160 sm:text-sm border-gray-300 rounded-md"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="fives"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Fives
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="fives"
                      id="fives"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="tens"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Tens
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="tens"
                      id="tens"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="fifteens"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Fifteens
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="fifteens"
                      id="fifteens"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="twenty_fives"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Twenty fives
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="twenty_fives"
                      id="twenty_fives"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="fifties"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Fifties
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="fifties"
                      id="fifties"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="hundreds"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Hundreds
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="hundreds"
                      id="hundreds"
                      onChange={handleChange}
                      className="shadow-sm focus:outline-none focus:ring-1 focus:ring-sky-500 focus:border-none block w-full sm:text-sm px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order summary */}
          <div className="mt-10 lg:mt-0">
            <h2 className="text-lg font-medium text-gray-900">Order summary</h2>

            <div className="mt-4 bg-white border border-gray-200 rounded-lg shadow-sm">
              <h3 className="sr-only">Items in your order</h3>

              <dl className="items-center border-t border-gray-200 py-6 px-4 sm:px-6 divide-y divide-gray-200">
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm font-medium">Type</div>
                  <div className="text-sm font-medium text-gray-900">
                    Quantity
                  </div>
                  <div className="text-sm font-medium text-gray-900">Price</div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Fives</div>
                  <div className="text-sm font-medium text-gray-900">
                    {fives}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {fives * 5}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Tens</div>
                  <div className="text-sm font-medium text-gray-900">
                    {tens}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {tens * 10}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Fifteens</div>
                  <div className="text-sm font-medium text-gray-900">
                    {fifteens}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {fifteens * 15}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Twenty fives</div>
                  <div className="text-sm font-medium text-gray-900">
                    {twenty_fives}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {twenty_fives * 25}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Fifties</div>
                  <div className="text-sm font-medium text-gray-900">
                    {fifties}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {fifties * 50}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 divide-x text-center">
                  <div className="text-sm">Hundreds</div>
                  <div className="text-sm font-medium text-gray-900">
                    {hundreds}
                  </div>
                  <div className="text-sm font-medium text-gray-900">
                    {hundreds * 100}
                  </div>
                </div>
                <div className="py-2 grid grid-cols-3 text-center border-t border-gray-200 pt-6">
                  <div className="text-base font-medium">Total</div>
                  <div></div>
                  <div className="text-base font-medium text-gray-900">
                    {handleSum()}
                  </div>
                </div>
              </dl>

              <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                <button
                  type="submit"
                  onClick={handleAddOrderClick}
                  className="w-full bg-sky-600 border border-transparent rounded-md shadow-sm py-3 px-4 text-base font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-sky-500"
                >
                  Confirm order
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
